import api from './api';

/**
 * Servicio para gestionar grados de secundaria
 */
export const gradosService = {
  /**
   * Obtiene todos los grados de secundaria (1º a 5º)
   * @returns {Promise<Array>} Lista de grados
   */
  getAll: async () => {
    try {
      const response = await api.get('/grados');
      return response.data || [];
    } catch (error) {
      console.error('Error al obtener grados:', error);
      throw error;
    }
  },

  /**
   * Obtiene un grado específico por ID
   * @param {number} id - ID del grado
   * @returns {Promise<Object>} Datos del grado
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/grados/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener grado ${id}:`, error);
      throw error;
    }
  },
};

export default gradosService;
